    $(document).ready(function () {
    var totalMilliseconds = new Date('2024-07-31 00:00:00').getTime();
    var countdownElement = $('#countdown'); 
    var countdownInterval; 
      
    function updateCountdown() {
        var now = new Date().getTime();
    var distance = totalMilliseconds - now; 

    
    if (distance < 0) {
        clearInterval(countdownInterval);
    countdownElement.text('end');
    return;
        }

    
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

   
    countdownElement.text(days + 'D - ' + hours.toString().padStart(2, '0') + 'H - ' + minutes.toString().padStart(2, '0') + 'M - ' + seconds.toString().padStart(2, '0') + 'S');
    }

  
    countdownInterval = setInterval(updateCountdown, 1000); 

   
    $(window).on('beforeunload', function () {
        clearInterval(countdownInterval);
    });
});